<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />
          <Button
            v-if="getUserPermission('CREATE_API_CLIENT')"
            :label="$t('Add')"
            size="md"
            @click="showModal('modal-lg')"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          sm="12"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <Button
              :label="$t('Filter')"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />

            <Button
              :label="$t('Reset Filter')"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="productProfileRef"
      :items="openAPIList"
      :busy="isBusy"
      :per-page="pageSize"
      :current-page="currentPage"
      responsive
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>
      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>

      <template #cell(lastAuthenticated)="data">
        {{ data.value ? toDateWithYear(data.value) : '' }}
      </template>
      <template #cell(dateCreated)="data">
        {{ data.value ? toDateWithYear(data.value) : '' }}
      </template>

      <template #cell(status)="data">
        <b-badge
          pill
          :variant="variantColor(data.value)"
        >
          {{ data.value }}
        </b-badge>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="getUserPermission('UPDATE_API_CLIENT')"
              @click="onSelectOpenAPIItem(data.item, $event.target, 'edit')"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50"> {{ $t('Modify') }} </span>
            </b-dropdown-item>

            <b-dropdown-item @click="onSelectOpenAPIItem(data.item, $event.target, 'view')">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50"> {{ $t('View') }} </span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="getUserPermission(data.item.status === 'Active' ? 'DEACTIVATE_API_CLIENT' : 'ACTIVATE_API_CLIENT')"
              @click="openAPIStatus(data.item, $event.target, data.index)"
            >
              <feather-icon icon="CheckSquareIcon" />
              <span class="align-middle ml-50">{{ data.item.status === 'Active' ? $t('Deactivate') : $t('Activate') }}</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="getUserPermission('REGENERATE_API_CLIENT_SECRET')"
              @click="onRegenerateClientSecret(data.item, $event.target)"
            >
              <feather-icon icon="RefreshCwIcon" />
              <span class="align-middle ml-50"> {{ $t('Regenerate Client Secret') }} </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>

    </b-table>

    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />

    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      :ok-title="buttonLabel"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      :ok-disabled="isLoading"
      centered
      size="lg"
      no-close-on-backdrop
      :title="modalTitle"
      @ok="handleSubmit"
      @hidden="resetModal"
    >
      <validation-observer ref="openAPIRules">
        <b-form @submit.prevent="handleSubmit">
          <b-row class="match-height">
            <!-- <b-col md="6">
              <InputField
                id="institution-id"
                v-model="openAPIFormData.institutionID"
                label="Institution ID"
                placeholder="Enter Institution ID"
                type="text"
                error-name="Institution ID"
                rules="required"
                :readonly="isReadonly"
              />
            </b-col> -->
            <b-col md="6">
              <InputField
                id="account-number"
                v-model="openAPIFormData.accountNumber"
                :label="$t('Account Number')"
                :placeholder="$t('Enter account number')"
                type="text"
                :readonly="isReadonly"
              />
            </b-col>
            <b-col md="6">
              <InputField
                id="email"
                v-model="openAPIFormData.email"
                :label="$t('Email')"
                :placeholder="$t('Enter email')"
                type="email"
                :error-name="$t('Email')"
                rules="required"
                :readonly="isReadonly"
              />
            </b-col>
            <!-- <b-col md="6">
              <InputNumberField
                id="api-access-fee"
                v-model="openAPIFormData.apiAccessFee"
                label="API Access Fee"
                placeholder="Enter API Access Fee"
                type="text"
                error-name="API Access Fee"
                rules="required"
                :readonly="isReadonly"
              />
            </b-col> -->
            <b-col md="6">
              <InputField
                id="webhook-URL"
                v-model="openAPIFormData.webhookURL"
                :label="$t('Webhook URL')"
                :placeholder="$t('Enter webhook URL')"
                type="text"
                :readonly="isReadonly"
              />
            </b-col>
            <b-col md="6">
              <InputField
                id="webhook-Username"
                v-model="openAPIFormData.webhookUserName"
                :label="$t('Webhook Username')"
                :placeholder="$t('Enter webhook username')"
                type="text"
                :readonly="isReadonly"
              />
            </b-col>
            <b-col md="6">
              <InputField
                id="webhook-password"
                v-model="openAPIFormData.webhookPassword"
                :label="$t('Webhook Password')"
                placeholder="**********"
                type="text"
                :readonly="isReadonly"
              />
            </b-col>
            <!-- <b-col md="6">
              <InputField
                id="access-rule-config"
                v-model="openAPIFormData.accessRuleConfig"
                label="Access Rule Config"
                placeholder="Enter Access Rule Config"
                type="text"
                :readonly="isReadonly"
              />
            </b-col> -->
            <b-col md="6">
              <InputField
                id="jwt-TokenExpirationMin"
                v-model="openAPIFormData.jwtTokenExpirationMin"
                :label="$t('JWT Token Expiration (In Minutes)')"
                :placeholder="$t('Enter JWT Token Expiration')"
                type="number"
                :readonly="isReadonly"
              />
            </b-col>
            <b-col md="6">
              <InputField
                id="enhancedVirtualProxyCollectionFeeGL"
                v-model="openAPIFormData.enhancedVirtualProxyCollectionFeeGL"
                :label="$t('Dynamic Account Fee GL')"
                :placeholder="$t('Enter Dynamic Account Fee GL')"
                type="text"
                :readonly="isReadonly"
              />
            </b-col>

            <b-col md="6">
              <b-form-group
                :label="$t('Permit Transfers From Account Without Parent Customer Id')"
                label-for="permit-transfers-from-account-without-parent-customer-id"
              >
                <b-form-radio-group
                  id="permit-transfers-from-account-without-parent-customer-id"
                  v-model="openAPIFormData.permitTransfersFromAccountWithoutParentCustomerId"
                  :options="translatedPermitTransfersOptions"
                  class="demo-inline-spacing"
                  name="permit-transfers-from-account-without-parent-customer-id"
                  stacked
                  value-field="value"
                  text-field="text"
                  :disabled="isReadonly"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                :label="$t('Permit Transactions On GL Accounts')"
                label-for="permit-transactions-on-gl-accounts"
              >
                <b-form-radio-group
                  id="permit-transactions-on-gl-accounts"
                  v-model="openAPIFormData.permitTransactionsOnGLAccounts"
                  :options="translatedPermitTransfersOptions"
                  class="demo-inline-spacing"
                  name="permit-transactions-on-gl-accounts"
                  stacked
                  value-field="value"
                  text-field="text"
                  :disabled="isReadonly"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <InputField
                id="specialAccountsForDebitOverrideAccess"
                v-model="openAPIFormData.specialAccountsForDebitOverrideAccess"
                :label="$t('If the above radio button is Yes, still permit transfers from the accounts')"
                :placeholder="$t('Enter Special Accounts For Debit Override Access')"
                type="text"
                :readonly="isReadonly"
              />
            </b-col>

            <b-col
              md="6"
            >
              <SelectField
                id="notification-preference"
                v-model="openAPIFormData.notificationPreference"
                :label="$t('Notification Preference')"
                :options="notificationPreferenceOptions"
                multiple
                :reduce="option => option"
                item="label"
                :placeholder="$t('Select')"
                :readonly="isReadonly"
              />
            </b-col>
            <b-col md="6">
              <SelectField
                id="notify-account-record-type-scope"
                v-model="openAPIFormData.otherNotificationConfig.notifyAccountRecordTypeScope"
                :label="$t('Notify Account Record Type Scope')"
                :options="translatedNotifyAccountRecordTypeScopeOptions"
                :reduce="option => option.value"
                item="label"
                :placeholder="$t('Select')"
                :readonly="isReadonly"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <SwitchButton
                v-model="openAPIFormData.limitReportsToProfileOwner"
                :label="$t('Limit Report To Profile Owner')"
                name="limit-report-profile"
                :readonly="isReadonly"
                :checked="true"
              />
            </b-col>
            <b-col md="6">
              <SwitchButton
                v-model="openAPIFormData.allowOutwardFeeOverride"
                :label="$t('Allow Outward Fee Override')"
                name="allow-outward-fee-override"
                :readonly="isReadonly"
                :checked="true"
              />
            </b-col>
          </b-row>

        </b-form>
      </validation-observer>
      <template
        v-if="isReadonly"
        #modal-footer="{ }"
      >
        <div />
      </template>
      <FullScreenSpinner :show="showSpinner" />
    </b-modal>
    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      :ok-title="$t('Apply')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      centered
      size="lg"
      :title="$t('Filters')"
      modal-footer
      @ok="fetchOpenAPI"
      @cancel="resetFilters"
    >
      <b-row class="match-height">
        <b-col md="6">
          <InputField
            id="account-number"
            v-model="filter.accountNumber"
            :label="$t('Account Number')"
            :placeholder="$t('Enter account number')"
            type="text"
          />
        </b-col>
        <b-col md="6">
          <InputField
            id="email"
            v-model="filter.email"
            :label="$t('Email')"
            :placeholder="$t('Enter email')"
            type="email"
            :readonly="isReadonly"
          />
        </b-col>
        <b-col md="6">
          <InputNumberField
            id="api-access-fee"
            v-model="filter.apiAccessFee"
            :label="$t('API Access Fee')"
            :placeholder="$t('Enter API Access Fee')"
            type="text"
            :readonly="isReadonly"
          />
        </b-col>
        <b-col md="6">
          <InputField
            id="webhook-Username"
            v-model="filter.webhookUserName"
            :label="$t('Webhook Username')"
            :placeholder="$t('Enter webhook username')"
            type="text"
          />
        </b-col>
        <b-col md="6">
          <InputField
            id="jwt-TokenExpirationMin"
            v-model="filter.jwtTokenExpirationMin"
            :label="$t('JWT Token Expiration (In Minutes)')"
            :placeholder="$t('Enter JWT Token Expiration')"
            type="number"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <SwitchButton
            v-model="filter.limitReportsToProfileOwner"
            :label="$t('Limit Report To Profile Owner')"
            name="limit-report-profile"
            :checked="true"
          />
        </b-col>
        <b-col md="6">
          <SwitchButton
            v-model="filter.allowOutwardFeeOverride"
            :label="$t('Allow Outward Fee Override')"
            name="allow-outward-fee-override"
            :checked="true"
          />
        </b-col>

      </b-row>
    </b-modal>
    <!-- Filter modal -->
    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BTable, BBadge,
  BDropdown, BModal, BForm, BSpinner, BDropdownItem, BFormGroup, BFormRadioGroup,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions } from 'vuex'
// import { v4 as uuidv4 } from 'uuid'
import { permissionMixin } from '@core/mixins/permission'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import InputField from '../../../forms/InputField.vue'
import InputNumberField from '../../../forms/InputNumberField.vue'
import SelectField from '../../../forms/SelectField.vue'
import SwitchButton from '../../../components/switch/Switch.vue'
import { toDateWithYear } from '@/helpers/formatDate'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import Button from '../../../components/button/Button.vue'
import { eChannelsPermission } from '@/helpers/permissions'

const notifyAccountRecordTypeScopeOptions = [
  { value: 'Notify_All_Acct_Debit_Credit', label: 'Notify All Account Debit Credit' },
  { value: 'Notify_All_Acct_Debit_Only', label: 'Notify All Account Debit Only' },
  { value: 'Notify_All_Acct_Credit_Only', label: 'Notify All Account Credit Only' },
  { value: 'Notify_Virtual_Acct_Only_Credit_And_Debit', label: 'Notify Virtual Account Only Credit And Debit' },
  { value: 'Notify_Virtual_Acct_Only_Debit_Only', label: 'Notify Virtual Account Only Debit Only' },
  { value: 'Notify_Virtual_Acct_Only_Credit_Only', label: 'Notify Virtual Account Only Credit Only' },
  { value: 'Notify_Other_Acct_Only_Credit_And_Debit', label: 'Notify Other Account Only Credit And Debit' },
  { value: 'Notify_Other_Acct_Only_Debit_Only', label: 'Notify Other Account Only Debit Only' },
  { value: 'Notify_Other_Acct_Only_Credit_Only', label: 'Notify Other Account Only Credit Only' },
]

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BDropdown,
    BSpinner,
    BDropdownItem,
    BModal,
    BBadge,
    BForm,
    BFormGroup,
    BFormRadioGroup,
    InputField,
    InputNumberField,
    SelectField,
    SwitchButton,
    ValidationObserver,
    TablePagination,
    Button,
    TableEntries,
    FullScreenSpinner,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toDateWithYear,
      sortBy: 'name',
      isReadonly: false,
      showSpinner: false,
      buttonLabel: this.$t('Save'),
      modalTitle: this.$t('Create Open API'),
      isSelectLevelThree: false,
      isBusy: false,
      required,
      sortDesc: false,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'name', sortable: true, label: 'Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
        { key: 'email', sortable: true, label: 'Email' },
        { key: 'webhookURL', sortable: true, label: 'Webhook URL' },
        { key: 'clientId', sortable: true, label: 'Client Id' },
        { key: 'apiAccessFee', sortable: true, label: 'API Access Fee' },
        { key: 'jwtTokenExpirationMin', sortable: true, label: 'JWT Token Expiration Min' },
        { key: 'specialAccountsForDebitOverrideAccess', sortable: true, label: 'Special Accounts For Debit Override Access' },
        { key: 'faildAuthenticationCount', sortable: true, label: 'Failed Authentication Count' },
        { key: 'lastAuthenticated', sortable: true, label: 'Last Authenticated' },
        { key: 'dateCreated', sortable: true, label: 'Date Created' },
        { key: 'enhancedVirtualProxyCollectionFeeGL', sortable: true, label: 'Enhanced Virtual Proxy Collection Fee GL' },
        { key: 'status', sortable: true, label: 'Status' },
        { key: 'actions', label: 'Actions' },
      ],
      permitTransfersOptions: [
        { text: 'Yes', value: true },
        { text: 'No', value: false },
      ],
      openAPIFormData: {
        // institutionID: '',
        accountNumber: null,
        email: null,
        // apiAccessFee: 0,
        webhookURL: null,
        webhookUserName: null,
        webhookPassword: null,
        specialAccountsForDebitOverrideAccess: '',
        // accessRuleConfig: '',
        jwtTokenExpirationMin: 0,
        notificationPreference: [],
        otherNotificationConfig: {
          notifyAccountRecordTypeScope: null,
        },
        enhancedVirtualProxyCollectionFeeGL: '',
        permitTransfersFromAccountWithoutParentCustomerId: false,
        permitTransactionsOnGLAccounts: false,
        limitReportsToProfileOwner: true,
        allowOutwardFeeOverride: true,
        id: '',
      },
      filter: {
        productCode: '',
        status: '',
      },
      openAPIList: [],
      notificationPreferenceOptions: [],
    }
  },
  computed: {
    translatedNotifyAccountRecordTypeScopeOptions() {
      return notifyAccountRecordTypeScopeOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedPermitTransfersOptions() {
      return this.permitTransfersOptions.map(item => ({ ...item, text: item.text ? this.$t(item.text) : item.value }))
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.fetchOpenAPI()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.fetchOpenAPI()
    },
  },
  mounted() {
    this.fetchOpenAPI()
    this.fetchNotificationPreference()
  },
  methods: {
    ...mapActions({
      getOpenAPI: 'eChannels/getOpenAPIList',
      getNotificationPreference: 'eChannels/getNotificationPreference',
      updateOpenAPI: 'eChannels/updateOpenAPIAction',
      createOpenAPI: 'eChannels/createOpenAPIAction',
      updateRegenerateClientSecret: 'eChannels/updateRegenerateClientSecret',
      updateOpenAPIStatus: 'eChannels/updateOpenAPIStatus',
    }),
    async fetchOpenAPI() {
      this.isBusy = true
      this.hideModal('modal-filter')
      try {
        const response = await this.getOpenAPI({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
          permission: eChannelsPermission.SEARCH_API_CLIENTS,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.openAPIList = data.data.map(items => ({
            ...items,
            // status: items.isActive === true ? 'Active' : 'InActive',
          }))
          this.totalCount = data.recordCount
        } else {
          this.openAPIList = []
          this.totalCount = 0
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async fetchNotificationPreference() {
      try {
        const { data, status } = await this.getNotificationPreference({
          permission: eChannelsPermission.SEARCH_API_CLIENTS,
        })
        if (status === 200 && data) {
          this.notificationPreferenceOptions = data
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },

    openAPIStatus(items) {
      const { id, status } = items
      const action = status === 'Active' ? this.$t('Deactivate') : this.$t('Activate')
      const cardStatus = status === 'Active' ? 'InActive' : 'Active'
      const permission = status === 'Active' ? eChannelsPermission.DEACTIVATE_API_CLIENT : eChannelsPermission.ACTIVATE_API_CLIENT

      const updateStatus = async () => {
        const yourText = this.$t('Your request to')
        try {
          this.showSpinner = true
          const statusValues = {
            id,
            status: cardStatus,
          }
          const response = await this.updateOpenAPIStatus({
            statusValues, routeName: 'APIClient', permission,
          })
          if (response.status === 200) {
            this.fetchOpenAPI()
            const successText = this.$t('Open API was successful')
            this.alertSuccess({ text: `${yourText} ${action} ${successText}` })
            this.showSpinner = false
          }
        } catch (error) {
          const reasonText = this.$t('Open API failed. Reason:')
          this.alertError({ text: `${yourText} ${action} ${reasonText} ${error}` })
        } finally {
          this.showSpinner = false
        }
      }
      const areYouSure = this.$t('Are you sure you want to')
      const thisText = this.$t('this Open API?')
      this.confirm(updateStatus, { title: '', text: `${areYouSure} ${action} ${thisText}` })
    },

    handleSubmit(bvModalEvt) {
      try {
        bvModalEvt.preventDefault()
        this.$refs.openAPIRules.validate().then(async success => {
          if (success) {
            const areYouSure = this.$t('Are you sure you want to')
            const thisText = this.$t('this Open API?')
            this.confirm(this.openAPIAction, { text: `${areYouSure} ${this.buttonLabel} ${thisText}` })
          }
        })
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.hideModal('modal-lg')
      }
    },
    async openAPIAction() {
      try {
        this.showSpinner = true
        this.isLoading = true
        const formData = {
          ...this.openAPIFormData,
          // institutionID: uuidv4(),
        }
        const response = this.buttonLabel === 'Save'
          ? await this.createOpenAPI({ formData, permission: eChannelsPermission.CREATE_API_CLIENT })
          : await this.updateOpenAPI({ formData, permission: eChannelsPermission.UPDATE_API_CLIENT })
        const { status } = response
        if (status === 200) {
          this.fetchOpenAPI()
          this.hideModal('modal-lg')
          const requestText = this.$t('Your request to')
          const successText = this.$t('Open API was successful')
          this.alertSuccess({ text: `${requestText} ${this.buttonLabel} ${successText}` })
          this.showSpinner = false
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
        this.isLoading = false
      }
    },
    onRegenerateClientSecret(items) {
      const { id } = items
      const permission = eChannelsPermission.REGENERATE_API_CLIENT_SECRET

      const updateStatus = async () => {
        try {
          this.showSpinner = true
          const statusValues = {
            id,
          }
          const response = await this.updateRegenerateClientSecret({
            statusValues, permission,
          })
          if (response.status === 200) {
            this.fetchOpenAPI()
            this.alertSuccess({ text: this.$t('Your new Client Secret key has been sent to your email') })
            this.showSpinner = false
          }
        } catch (error) {
          this.handleError(error)
        } finally {
          this.showSpinner = false
        }
      }
      this.confirm(updateStatus, { title: '', text: this.$t('Are you sure you want to Regenerate Client Secret?') })
    },

    async onSelectOpenAPIItem(items, activity, val) {
      try {
        this.openAPIFormData = {
          accountNumber: items.accountNumber,
          email: items.email,
          specialAccountsForDebitOverrideAccess: items.specialAccountsForDebitOverrideAccess,
          // apiAccessFee: 0,
          webhookURL: items.webhookURL,
          webhookUserName: items.webhookUserName,
          webhookPassword: items.webhookPassword,
          // accessRuleConfig: items.accessRuleConfig,
          jwtTokenExpirationMin: items.jwtTokenExpirationMin,
          enhancedVirtualProxyCollectionFeeGL: items.enhancedVirtualProxyCollectionFeeGL,
          notificationPreference: items.notificationPreference,
          otherNotificationConfig: {
            notifyAccountRecordTypeScope: items.otherNotificationConfig.notifyAccountRecordTypeScope,
          },
          permitTransfersFromAccountWithoutParentCustomerId: items.permitTransfersFromAccountWithoutParentCustomerId,
          permitTransactionsOnGLAccounts: items.permitTransactionsOnGLAccounts,
          limitReportsToProfileOwner: items.limitReportsToProfileOwner,
          allowOutwardFeeOverride: items.allowOutwardFeeOverride,
          id: items.id,
        }
        this.isReadonly = val !== 'edit'
        this.modalTitle = val === 'edit' ? this.$t('Edit Open API') : this.$t('View Open API')
        this.buttonLabel = this.$t('Update')
        this.$root.$emit('bv::show::modal', 'modal-lg')
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    resetFilters() {
      this.filter = { ...null }
    },
    resetFilter() {
      this.filter = { ...null }
      this.fetchOpenAPI(
        this.currentPage = 1,
        this.perPage = 10,
        this.totalCount = 1,
      )
    },
    resetModal() {
      this.openAPIFormData = {
        accountNumber: null,
        email: null,
        webhookURL: null,
        webhookUserName: null,
        webhookPassword: null,
        // accessRuleConfig: null,
        jwtTokenExpirationMin: 0,
        specialAccountsForDebitOverrideAccess: null,
        enhancedVirtualProxyCollectionFeeGL: '',
        notificationPreference: [],
        otherNotificationConfig: {
          notifyAccountRecordTypeScope: null,
        },
        permitTransfersFromAccountWithoutParentCustomerId: false,
        permitTransactionsOnGLAccounts: false,
        limitReportsToProfileOwner: true,
        allowOutwardFeeOverride: true,
        id: '',
      }
      this.isReadonly = false
      this.isLoading = false
      this.modalTitle = this.$t('Create Open API')
      this.buttonLabel = this.$t('Save')
    },
  },
}
</script>
